module.exports = __webpack_public_path__ + "files/8fe5364bdac668a8f20d8d06c1e37e72.png";